import React from 'react';
import Banner from './Banner';

function Footer() {
    return (
        <footer>
            <Banner />
            <p>© Copyright RUC Bible Study Department {new Date().getFullYear()}. All Right Reserved. Designed and Developed by <strong><a href='https://taiwojoshua.netlify.app/' target='_blank' rel='noreferrer'>Taiwo Joshua</a></strong></p>
        </footer>
    );
}

export default Footer;